import FirebaseApp from 'firebase/app'
import credentials from './credentials'

export const Firebase = FirebaseApp.initializeApp(credentials.config);
